import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useSearchParams } from 'react-router-dom'
import { selectCountry } from '../../../../common/category/store/slice'
import { Element } from '../../../../common/html/element'
import { Loading } from '../../../../common/loading'
import { DEFAULT_CODE } from '../../../../layout/header/search/constants'
import { PreviewCompanyInfo } from '../../../common/previewCompanyInfo'
import classes from '../index.module.scss'
import { selectCompanyInfoData, selectLoading } from '../store/slice'
import { getInternationalCompanyDetail } from '../store/thunk'

export const PreviewLeft = () => {
  const dispatch = useDispatch()
  const [searchParams] = useSearchParams()
  const companyId = searchParams.get('companyId')

  const data = useSelector(selectCompanyInfoData)
  const country = useSelector(selectCountry)
  const loading = useSelector(selectLoading)
  const locale = useSelector((state) => state.i18n.locale)

  useEffect(() => {
    if (!country.code || country.code === DEFAULT_CODE) return

    dispatch(
      getInternationalCompanyDetail({
        CompanyId: companyId,
        CountryCode: country.code,
      }),
    )
  }, [companyId, country, locale])

  return (
    <div className={[' positionRelative', classes.w33].join(' ')}>
      {loading && <Loading />}
      {!loading && (
        <>
          <Element
            className="textUppercase fw600"
            style={{ color: '#0553A5', fontSize: 24, marginBottom: 12 }}
          >
            {data.companyName || ''}
          </Element>
          <PreviewCompanyInfo data={data} />
        </>
      )}
    </div>
  )
}
